import {
  accountStatusUpdated,
  appSync,
  socketConnected,
  startListening,
} from '@betty/toolkit/state';
import { isAnyOf } from '@reduxjs/toolkit';
import { getAccount, selectAccountStatus, setAccount } from './account.slice';
import { AccountStatusChangedEventData } from './account.types';
import { logout } from '../../../../auth/lib/state/auth/auth.slice';
import { BottomSheet } from '@betty/navigation';
import { AsyncStorage } from '@betty/toolkit/storage';
import {
  SOF_BOTTOM_SHEET_LAST_SHOW_TIME_STORAGE_KEY,
  SOF_BOTTOM_SHEET_SHOW_INTERVAL,
} from '../../bottomSheets';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(getAccount());
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const connection = action.payload;

    connection.on(
      'AccountStatusChanged',
      (data: AccountStatusChangedEventData) => {
        dispatch(
          setAccount({
            status: data.accountStatus,
            statusReason: data.accountStatusReason,
            verificationMeta: data.verificationMeta,
          }),
        );
        dispatch(accountStatusUpdated());
      },
    );
  },
});

startListening({
  matcher: isAnyOf(getAccount.fulfilled, setAccount),
  effect: (_, { getState, dispatch, cancelActiveListeners }) => {
    cancelActiveListeners();

    const state = getState();
    const accountStatus = selectAccountStatus(state);

    if (
      accountStatus === 'Suspended' ||
      accountStatus === 'Closed' ||
      accountStatus === 'SelfExclusion'
    ) {
      dispatch(logout());
    }
  },
});

startListening({
  actionCreator: getAccount.fulfilled,
  effect: async (action, { dispatch }) => {
    dispatch(accountStatusUpdated());

    const { sourceOfFundsForm } = action.payload;

    if (!sourceOfFundsForm || sourceOfFundsForm.isCompleted) {
      return;
    }

    const { id } = sourceOfFundsForm;

    const SOFBottomSheetAsyncStorageData =
      (await AsyncStorage.getItem(
        SOF_BOTTOM_SHEET_LAST_SHOW_TIME_STORAGE_KEY,
      )) ?? '{}';

    const { formId, time: lastShowTime } = await JSON.parse(
      SOFBottomSheetAsyncStorageData,
    );

    if (
      Date.now() - lastShowTime >= SOF_BOTTOM_SHEET_SHOW_INTERVAL ||
      id !== formId
    ) {
      BottomSheet.open({
        namespace: 'account',
        type: 'SOF',
      });
    }
  },
});
